<template>
	<transition>
		<g v-if='!hidden'>
			<text v-if="country" class="country" :x="pos[0]" :y="pos[1]+20">{{country}}</text>
			<text v-if="subdivision && !city" class="subdivision" :x="pos[0]" :y="pos[1]+20+12">{{subdivision}}</text>
			<text v-if="city" class="city" :x="pos[0]" :y="pos[1]+20+12">{{city}}</text>
		</g>
	</transition>
</template>

<script>
	import * as d3 from "d3";

	export default {
		name: "MapLabel",
		props: {
			pos: {},
			country: {},
			subdivision: {},
			city: {},
			hidden: true
		},
		computed: {
			innerD: function () {
				return d3.symbol().type(this.symbol).size(30)();
			},
			outerD: function () {
				return d3.symbol().type(this.symbol).size(60)();
			},
			translate: function () {
				return "translate(" + this.point[0] + " " + this.point[1] + ")";
			},
		},
		mounted() {
			if (this.symbol !== d3.symbolCircle) {
				return
			}
			this.styles = {
				"stroke-dashoffset": -3,
				"stroke-dasharray": this.$refs.outer.getTotalLength() / 4,
			};
		},
	}
</script>

<style scoped>
	g {
		opacity: 0.8;
		transition: opacity 0.5s;
	}

	.v-enter {
		opacity: 0;
	}

	.v-leave-to {
		opacity: 0;
	}

	.country, .subdivision, .city {
		font-family: Roboto, sans-serif;
		text-anchor: middle;
		fill: #dddddd;
	}

	.country {
		font-size: 12px;
	}

	.subdivision, .city {
		font-size: 10px;
	}
</style>